import React from 'react';
import { NavLink } from 'react-router-dom';
import { ONBOARDING_TOUR_TARGETS } from '../../../services/onboardingTourService';

const SECURITY_LINKS = [
  {
    to: '/settings/security/access-controls',
    label: 'Access controls',
  },
  {
    to: '/settings/security/policies',
    label: 'Policies',
  },
  {
    to: '/settings/security/assignments',
    label: 'Role assignments',
  },
  {
    to: '/settings/security/registered-devices',
    label: 'Registered Devices',
  },
] as const;

export const SecuritySubnav: React.FC = () => (
  <div className="rounded-2xl border border-gray-200 bg-white px-5 pt-4">
    <div className="flex flex-wrap gap-6">
      {SECURITY_LINKS.map((link) => (
        <NavLink
          key={link.to}
          to={link.to}
          data-onboarding-tour={
            link.to === '/settings/security/access-controls'
              ? ONBOARDING_TOUR_TARGETS.securityAccessControlsLink
              : undefined
          }
          className={({ isActive }) =>
            [
              'border-b-2 pb-4 text-sm font-semibold transition-colors',
              isActive
                ? 'border-pos-primary text-pos-primary'
                : 'border-transparent text-gray-500 hover:text-gray-900',
            ].join(' ')
          }
        >
          {link.label}
        </NavLink>
      ))}
    </div>
  </div>
);
